import React, { Suspense } from 'react';
import useLayout from '@context/layout/useLayout';
import { styRightPanel } from './style';
import items from './items';

const RightPanel = () => {
  const { rightPanel } = useLayout();

  const activeItemId = rightPanel.itemKey;
  const activeItem = items.find(({ id }) => id === activeItemId);
  const Element = activeItem?.element;

  return (
    <div className={styRightPanel}>
      <Suspense fallback={null}>{Element && <Element />}</Suspense>
    </div>
  );
};

export default RightPanel;
